<template>
  <div class="device-detail-history-traditional">
    <!-- 过滤 -->
    <div class="query-filter">
      <div class="select-date">
        <h1>{{ $t('ddh_traditional_ri_qi') }}</h1>
        <div style="margin-bottom: 16px">
          <custom-date-picker :clearable="false" v-model="selectDate" type="daterange"
            style="width: 250px" value-format="YYYY-MM-DD HH:mm:ss" :init-value="initDate" :picker-options="beforeToday"
            @init="refreshPage" @change="refreshPage"></custom-date-picker>
        </div>
      </div>
      <div class="tab-box" style="height: 40px">
        <el-tabs v-model="workClass" v-if="tabData.length">
          <el-tab-pane v-for="item in tabData" :label="item.name" :name="item.value" :key="item.value"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="chart-box">
      <div class="sheet-info">
        <ul class="box">
          <!-- 全部 -->
          <template v-if="`${workClass}` === '0'">
            <li class="item">
              <p class="mode">{{ $t('ddh_traditional_qjsc') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.totalUsageTime === 0 ? '-' : $formatSecToHm(info.totalUsageTime) }}</p>
                </li>
              </ul>
            </li>
            <li class="item">
              <p class="mode">{{ $t('ddh_traditional_qing_jie_mian_ji') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.totalCleanArea === 0 ? '-' : $formatAreaToUnit($toFixed(info.totalCleanArea)) }}</p>
                </li>
              </ul>
            </li>
            <li class="item">
              <p class="mode">{{ $t('ddh_traditional_qing_jie_ci_shu') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.totalUsageCount }}</p>
                </li>
              </ul>
            </li>
            <li class="item" v-if="isAutonomous">
              <p class="mode">{{ $t('ddh_traditional_xie_zhu_ci_shu') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.assistCount }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 手工-->
          <template v-if="isManual && `${workClass}` === '2'">
            <li class="item">
              <p class="mode">{{ $t('ddh_traditional_sgqjsj') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.manualUsageTime === 0 ? '-' : $formatSecToHm(info.manualUsageTime) }}</p>
                </li>
              </ul>
            </li>
            <li class="item">
              <p class="mode">{{ $t('ddh_traditional_sgqjmj') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.manualCleanArea === 0 ? '-' : $formatAreaToUnit($toFixed(info.manualCleanArea)) }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 智能清洁-->
          <template v-if="isAutonomous && `${workClass}` === '5'">
            <li class="item">
              <p class="mode">{{ $t('ddh_traditional_znqjsj') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.autonomousUsageTime === 0 ? '-' : $formatSecToHm(info.autonomousUsageTime) }}</p>
                </li>
              </ul>
            </li>
            <li class="item">
              <p class="mode">{{ $t('ddh_traditional_znqjmj') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.autonomousCleanArea === 0 ? '-' : $formatAreaToUnit($toFixed(info.autonomousCleanArea)) }}
                  </p>
                </li>
              </ul>
            </li>
            <li class="item">
              <p class="mode">{{ $t('ddh_traditional_fu_zhu_ci_shu') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.assistCount }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 教学 -->
          <template v-if="isTraining && `${workClass}` === '4'">
            <li class="item">
              <p class="mode">{{ $t('ddh_traditional_jxqjsc') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.trainingUsageTime === 0 ? '-' : $formatSecToHm(info.trainingUsageTime) }}</p>
                </li>
              </ul>
            </li>
            <li class="item">
              <p class="mode">{{ $t('ddh_traditional_jxqjmj') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.trainingCleanArea === 0 ? '-' : $formatAreaToUnit($toFixed(info.trainingCleanArea)) }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 充电-->
          <!-- v-if="isCharging && `${workClass}` === '1'" -->
          <template v-if="`${workClass}` === '0' || `${workClass}` === '1'">
            <li class="item">
              <p class="mode">{{ $t('ddh_traditional_cdsc') }}</p>
              <ul>
                <li class="param">
                  <p>{{ info.chargingTime === 0 ? '-' : $formatSecToHm(info.chargingTime) }}</p>
                </li>
              </ul>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <div class="table-list">
      <div class="header">
        <div class="label">{{ $t('ddh_traditional_sjxq') }}</div>
        <div class="search-content">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item style="float: right; margin-right: 0">
              <custom-column ref="column"></custom-column>
            </el-form-item>
            <el-form-item style="float: right">
              <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
            </el-form-item>
            <el-form-item style="float: right" v-if="funcView.device_detail_record_export">
              <el-button class="custom-btn" icon="icon icon-export-excel left-icon" type="info" round
                @click="exportHistory">{{ $t('com_export') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 过滤 -->
      <div class="query-filter" style="margin-top: 24px; width: 100%; padding: 0" v-if="isFilter">
        <div class="params-form">
          <el-row :gutter="23">
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('ddh_traditional_ka_hao') }}</div>
                <div class="value">
                  <el-input v-model="formSearch.bootCardNum" @input="onPageChange({ page: 1 })" clearable
                    :placeholder="$t('com_please_input')"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('ddh_traditional_mo_shi') }}</div>
                <div class="value">
                  <custom-select code="iot_tsl_use_type2" v-model="formSearch.workClass" @change="onWorkClassChange"
                    :placeholder="$t('com_please_select')" width="100%" theme="yellow"></custom-select>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('ddh_traditional_chi_ka_ren') }}</div>
                <div class="value">
                  <el-input v-model="formSearch.bootCardOwner" @input="onPageChange({ page: 1 })" clearable
                    :placeholder="$t('com_please_input')"></el-input>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="filter-values">
          <div class="label">{{ $t('ddh_traditional_shai_xuan_xiang') }}：</div>
          <div class="values">
            <el-tag v-if="formSearch.bootCardNum" closable @close="
              formSearch.bootCardNum = '';
            onPageChange({ page: 1 });
            ">
              {{ formSearch.bootCardNum }}
            </el-tag>
            <el-tag closable v-for="workClassTag in workClassList" :key="workClassTag.value"
              @close="onCloseTag(workClassTag.value, 'workClassList', 'workClass')">{{ workClassTag.label }}</el-tag>
            <el-tag v-if="formSearch.bootCardOwner" closable @close="
              formSearch.bootCardOwner = '';
            onPageChange({ page: 1 });
            ">
              {{ formSearch.bootCardOwner }}
            </el-tag>
            <span class="clear" @click="onClear">{{ $t('com_clear') }}</span>
          </div>
        </div>
      </div>
      <div class="table-bd">
        <custom-table v-if="isUs" tableCode="portal_device_sheet_usage_ft" :data="historyList" :index="true"
          @sort="sortChange" @column="setColumn" @filter="filterChange"
           :slots="['runRoute','cleanedArea','runLength']"
          >
          <!--
            manualCleanArea
            autonomousCleanArea
            trainingCleanArea
          -->
          <template v-slot:cleanedArea="scope">
            <span>{{$formatLenLocal(scope.row.cleanedArea)}}</span>
          </template>
          <template v-slot:runLength="scope">
            <span>{{$formatLenLocal(scope.row.runLength,true)}}</span>
          </template>
          <template v-slot:runRoute="scope">
            <span
              v-if="!!scope.row.routeId && (`${scope.row.workClass}` === '5' || `${scope.row.workClass}` === '4')"
              style="cursor: pointer; color: #0d9ae0"
              @click="mapIdDetails(scope.row.routeId, scope.row.workClass)"
            >
              {{ $t('com_detail') }}
            </span>
          </template>
        </custom-table>
        <custom-table v-else tableCode="portal_device_sheet_usage" :data="historyList" :index="true" @sort="sortChange"
          @column="setColumn" @filter="filterChange"
          :slots="['runRoute']"
          >
            <template v-slot:runRoute="scope">
              <span
                v-if="!!scope.row.routeId && (`${scope.row.workClass}` === '5' || `${scope.row.workClass}` === '4')"
                style="cursor: pointer; color: #0d9ae0"
                @click="mapIdDetails(scope.row.routeId, scope.row.workClass)"
              >
                {{ $t('com_detail') }}
              </span>
            </template>
        </custom-table>
      </div>
      <div class="table-footer">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize"
          @change="onPageChange"></custom-pagination>
      </div>
      <!-- 查看地图图片 -->
      <el-image-viewer v-if="dialogVisibleImage" class="img"  :url-list="[dialogImageUrl]"  :on-close="()=>dialogVisibleImage=false" ></el-image-viewer>
    </div>
  </div>

  <!-- </div> -->
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';

// ddh_traditional_ri_qi: 日期// ddh_traditional_qjsc: 清洁时长// ddh_traditional_qing_jie_mian_ji: 清洁面积// ddh_traditional_qing_jie_ci_shu: 清洁次数// ddh_traditional_xie_zhu_ci_shu: 协助次数// ddh_traditional_sgqjsj: 手工清洁时间// ddh_traditional_sgqjmj: 手工清洁面积// ddh_traditional_znqjsj: 智能清洁时间// ddh_traditional_znqjmj: 智能清洁面积// ddh_traditional_fu_zhu_ci_shu: 辅助次数// ddh_traditional_jxqjsc: 教学清洁时长// ddh_traditional_jxqjmj: 教学清洁面积// ddh_traditional_cdsc: 充电时长// ddh_traditional_sjxq: 数据详情// ddh_traditional_ka_hao: 卡号// ddh_traditional_mo_shi: 模式// ddh_traditional_chi_ka_ren: 持卡人// ddh_traditional_shai_xuan_xiang: 筛选项

export default {
  name: 'history-traditional',
  props: {
    deviceInfo: {
      type: Object,
      default: () => ({}),
    },
    tabData: {
      type: Array,
      default: () => [],
    },
    isCharging: {
      type: Boolean,
      default: false,
    },
    isManual: {
      type: Boolean,
      default: false,
    },
    isAutonomous: {
      type: Boolean,
      default: false,
    },
    isTraining: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  computed: {},
  data() {
    return {
      selectDate: [],
      initDate: '',
      beforeToday: {},
      workClass: '0',
      useType: '',
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        bodyNum: '',
        startTime: '',
        endTime: '',
        bootCardNum: '',
        workClass: '',
        bootCardOwner: '',
      },
      totalRows: null,
      workClassList: [],
      data: [],
      monthList: [],
      info: {
        // 总
        totalCleanArea: '', // 总清洁面积
        totalUsageCount: '', // 总清洁次数
        totalUsageTime: '', // 总清洁时长
        // 手工
        manualUsageTime: '',
        manualCleanArea: '',
        // 智能
        autonomousUsageTime: '',
        autonomousCleanArea: '',
        // 教学
        trainingCleanArea: '',
        trainingUsageTime: '',
        assistCount: '',
        // 充电
        chargingTime: '',
      },
      // monthPage: [],
      historyList: [],
      supportMode: '',
      modeTypeList: [],
      filterArr: [],
      iot_tsl_use_type2: {},
      iot_tsl_use_type2_value: {},
      dms_boot_card_color_value: {},
      isFilter: false,

      dialogVisibleImage: false,
      dialogImageUrl: '',
    };
  },
  watch: {
    workClass(val) {
      if (val) {
        if (`${this.workClass}` !== '0') {
          this.formSearch.workClass = this.workClass;
        } else {
          this.formSearch.workClass = '';
        }
        // 重置分页
        this.formSearch.pageNum = 1;
        this.getInfo();
        this.getReportPage();
      }
    },
  },
  // created() {
  //   // 不需要与视图交互的变量都定义在created这里
  //   this.refreshTimer = null;
  //   this.scrollProportion = 0;
  //   this.chart = null;
  //   this.chartView = null;
  //   this.ds = null;
  //   this.mapArr = [];
  // },
  mounted() {
    this.mergeLanguage(null, 'portal_device_detail_history_traditional');
    this.getFuncView('/other/device');
    // this.getTableColumn();
    this.getDictionary('iot_tsl_use_type2,dms_boot_card_color', (data) => {
      this.iot_tsl_use_type2 = data.iot_tsl_use_type2;
      this.iot_tsl_use_type2_value = this.$transformDicValue(data.iot_tsl_use_type2);
      this.dms_boot_card_color_value = this.$transformDicValue(data.dms_boot_card_color);
    });
    // 已到期设备用已到期的时候
    this.initDate = this.deviceInfo.unbindOrgTime
      ? [
        `${moment(this.deviceInfo.unbindOrgTime).subtract(15, 'days').format('YYYY-MM-DD')} 00:00:00`,
        `${moment(this.deviceInfo.unbindOrgTime).format('YYYY-MM-DD')} 23:59:59`,
      ]
      : [`${moment(this.$getLocalTime()).subtract(15, 'days').format('YYYY-MM-DD')} 00:00:00`, `${moment(this.$getLocalTime()).subtract(1, 'days').format('YYYY-MM-DD')} 23:59:59`];
    const beforeTime = this.deviceInfo.unbindOrgTime ? this.deviceInfo.unbindOrgTime : this.$getLocalTime();
    this.beforeToday = {
      disabledDate: time => moment(time).isAfter(beforeTime, 'day')
    };
    this.formSearch.bodyNum = this.deviceInfo.bodyNum || '';
    // this.getInfo();
    // this.getReportPage();
  },
  methods: {
    // 月 周 table
    getReportPage: function () {
      this.formSearch.startTime = moment
        .utc(this.$momentElLocal(this.selectDate[0]))
        .utcOffset(this.deviceInfo.utcReportOffset || 0)
        .format('YYYY-MM-DD HH:mm:ss');
      this.formSearch.endTime = moment
        .utc(this.$momentElLocal(this.selectDate[1]))
        .utcOffset(this.deviceInfo.utcReportOffset || 0)
        .format('YYYY-MM-DD HH:mm:ss');
      // this.formSearch.workClass = `${this.workClass}` === '0' ? '' : this.workClass;
      this.$getJSON(apis.deviceReportWorkRunPage, this.formSearch).then((res) => {
        // this.historyList = res.data.list;
        const data = res.data.list || [];
        this.nullValueToCrossbar(data, ['assistCount']);
        this.historyList = data;
        this.totalRows = res.data.total;
      });
    },
    // 年报表 季度 月 周 info
    getInfo: function () {
      this.$getJSON(apis.deviceReportWorkRunCount, this.formSearch).then((res) => {
        if (res.data && Object.keys(res.data).length !== 0) {
          this.$setFormatData(this.info, res.data);
        } else {
          // 总
          this.info.totalCleanArea = '';
          this.info.totalUsageCount = '';
          this.info.totalUsageTime = '';
          // 手工
          this.info.manualUsageTime = '';
          this.info.manualCleanArea = '';
          // 智能
          this.info.autonomousUsageTime = '';
          this.info.autonomousCleanArea = '';
          // 智能

          this.info.trainingUsageTime = '';
          this.info.trainingCleanArea = '';
          this.info.assistCount = '';
          // 充电
          this.info.chargingTime = '';
        }
      });
    },
    getWorkClass(workClass) {
      // "1": "充电", "2": "清洁", "4": "教学", "5": "自动"
      if (`${workClass}` === '1') {
        return 'charging';
      }
      if (`${workClass}` === '2') {
        return 'manual';
      }
      if (`${workClass}` === '4') {
        return 'training';
      }
      if (`${workClass}` === '5') {
        return 'auto';
      }
      return '';
    },
    // 删除标签
    onCloseTag(value, tagList, key) {
      this[tagList] = this[tagList].filter(item => item.value !== value);
      this.formSearch[key] = this[tagList].map(item => item.value);
      this.onPageChange({ page: 1 });
    },
    // 清空标签
    onClear() {
      this.workClassList = [];
      this.formSearch.bootCardNum = '';
      this.formSearch.workClass = '';
      this.formSearch.bootCardOwner = '';
      this.onPageChange({ page: 1 });
    },
    // 其他状态
    onWorkClassChange(data) {
      const workClassName = this.formSearch.workClass;
      if (!data || !data.value) {
        this.workClassList = [];
      } else {
        this.workClassList = [
          {
            label: data.name,
            value: workClassName,
          },
        ];
      }
      this.onPageChange({ page: 1 });
    },

    // 导出数据
    exportHistory: function () {
      this.$exportFlie(apis.deviceReportWorkRunExport, { ...this.formSearch, tableCode: this.isUs ? 'portal_device_sheet_usage_ft' : 'portal_device_sheet_usage' }).then(() => { });
    },
    refreshPage() {
      this.getInfo();
      this.getReportPage();
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getReportPage();
    },
    mapIdDetails(routeId, workClass) {
      // w是自主
      // t是教学
      let type = '';
      if (`${workClass}` === '5') {
        type = 'w';
      } else if (`${workClass}` === '4') {
        type = 't';
      }
      if (!routeId || !type) {
        return;
      }
      this.$getJSON(`${apis.OssAttach}/${routeId}/${type}`).then((res) => {
        const list = res.data || [];
        const url = this.getAttachUrl(list[0]);
        this.dialogImageUrl = url;
        this.dialogVisibleImage = true;
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.device-detail-history-traditional {
  .select-date {
    h1 {
      font-size: 12px;
      line-height: 17px;
      font-weight: bold;
      color: $--color-primary;
      margin-bottom: 4px;
    }

    .el-date-editor {
      transform: translateX(-8px);
    }

    input {
      font-weight: bold;
    }

    .el-range__close-icon.el-input__icon:after {
      font-family: 'icon' !important;
      content: '\E7F8';
      font-size: 22px;
      line-height: 42px;
      margin-right: 30px;
      color: $--color-warning;
    }

    .el-input__icon.el-range__icon.el-icon-date {
      color: $--color-primary;
      font-size: 18px;
      margin-top: 2px;
    }

    .el-input .el-input__inner {
      cursor: pointer;
      height: 40px;
      line-height: 41px;
      padding-left: 34px;
      font-weight: bold;
      color: $--color-text-primary;
    }
  }

  .el-tabs .el-tabs__item {
    font-size: 14px;
  }

  .chart-box {
    background: #ffffff;
    border-radius: 16px;
    margin-top: 24px;
    padding: 0 24px;

    .sheet-info {
      padding: 24px 24px 24px 0;

      .box {
        padding: 0 16px;
        display: flex;

        li.item {
          border-right: 1px solid #e9ebec;
          margin-left: 32px;
          width: 150px;

          &:first-child {
            margin: 0;
          }

          .mode {
            font-size: 12px;
            font-weight: bold;
            color: $--color-text-secondary;
            line-height: 17px;
          }

          ul {
            display: flex;
            margin-top: 4px;

            .param {
              padding-right: 32px;

              // h2 {
              //   height: 17px;
              //   font-size: 12px;
              //   color: rgba(152, 166, 173, 1);
              //   line-height: 17px;
              //   margin-bottom: 5px;
              // }
              p {
                height: 25px;
                font-size: 18px;
                font-weight: bold;
                color: $--color-text-primary;
                line-height: 25px;
              }
            }
          }

          &:last-of-type {
            border: none;
          }
        }
      }

      .time {
        color: #0d9ae0;
      }

      .box-bottom {
        margin-top: 16px;
        text-align: right;
        height: 17px;
        font-size: 12px;
        color: #6c757d;
        line-height: 17px;
      }
    }
  }

  .table-list {
    background: #ffffff;
    border-radius: 16px;
    padding: 24px 24px 0;
    margin-top: 24px;

    .header {

      // padding: 24px;
      .label {
        color: #1a1a1a;
        line-height: 40px;
        font-weight: bold;
        float: left;
      }

      .search-content {
        float: right;
      }

      .icon-filter {
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        font-size: 16px;
        width: 40px;
        height: 40px;
        color: $--color-text-primary;
        box-shadow: 0 0 0 1.5px #202945 inset;
        border-radius: 50px;
        cursor: pointer;
      }
    }

    .title {
      height: 40px;
      font-size: 18px;
      font-weight: bold;
      color: #1a1a1a;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
    }

    .table-bd {
      background: #ffffff;
      border-radius: 16px;
      padding: 24px 24px 0;
      margin-top: 24px;

      .table-head {
        height: 40px;
        display: flex;
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        width: 100%;

        li {
          width: 0;
          line-height: 40px;
          font-size: 14px;
          font-weight: bold;
          color: $--color-text-secondary;
        }
      }

      .table-body {
        height: 250px;
        overflow-y: auto;

        .line {
          height: 48px;

          &:nth-of-type(even) {
            background-color: #f8f9fa;
          }

          .content {
            cursor: pointer;
            height: 48px;
            line-height: 48px;
            display: flex;
            width: 100%;
            padding: 0 16px;

            li {
              width: 0;
              line-height: 48px;
              font-size: 14px;
              color: $--color-text-regular;

              .use-type {
                height: 26px;
                border-radius: 47px;
                line-height: 18px;
                font-size: 12px;
                font-weight: 400;
                color: #ffffff;
                padding: 4px 10px;
                display: inline-block;

                &.manual {
                  background: $--color-success;
                }

                &.auto {
                  background: $--color-primary;
                }

                &.charging {
                  background: $--color-warning;
                }

                &.training {
                  background: $--color-text-primary;
                }
              }
            }

            .date {
              font-weight: bold;
            }
          }
        }

        .no-data {
          margin-top: 24px;
          height: 130px;
          text-align: center;
          line-height: 130px;
          font-size: 16px;
          color: #818181;
          background: #ffffff;
          border-radius: 16px;
        }
      }
    }
  }
}
</style>
